import{ useContext } from 'react';
import { AuthContext } from '../authProvider/AuthProvider';

const UseAuth = () => {
    const auth=useContext(AuthContext)
    return auth;
};

export default UseAuth;